module.exports = __webpack_public_path__ + "img/tooltip_05-vallone-como-29.edc93240.jpg";